import { Component, ElementRef, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMenu } from './app.menu';
import { AuthService } from '@/services/auth.service';
import { PermissoesService } from '@/services/permissoes.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu, CommonModule],
    template: ` <div class="layout-sidebar">
        <app-menu></app-menu>

        @if (hasMotoClubeRegistrosAccess()) {
            <div class="p-2 m-1 mt-1 bg-red-100 border border-red-400 text-red-700 rounded text-sm shadow-sm">
                <div class="flex flex-col gap-1">
                    <span class="font-semibold">Banco Bradesco S.A.</span>
                    <span>Ag: <span class="font-mono">0614</span></span>
                    <span>CC: <span class="font-mono">327402-0</span></span>
                    <span class="break-all">PIX: motoclube@ieqcedsp.org.br</span>
                    <span class="font-bold uppercase text-xs tracking-wide">IEQ CED TAXAS</span>
                </div>
            </div>
        }
    </div>`
})
export class AppSidebar {
    private authService = inject(AuthService);
    private permissoesService = inject(PermissoesService);

    constructor(public el: ElementRef) {}

    hasMotoClubeRegistrosAccess = computed(() => {
        const user = this.authService.currentUser();
        return this.permissoesService.hasPermission(user, 'MotoClubeRegistros');
    });
}
